import { IGetProject, IGetCustomProject } from '../../../Models/IGetProject';
import { IGetDataset } from '../../../Models/IGetDataset';

export const DATASETTYPE = 'datasetType';
export const DATASETFORMAT = 'datasetFormat';

export const isDataset = (item: IGetDataset | IGetProject | IGetCustomProject) => {
  return DATASETFORMAT in item;
};
